<template></template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        timerSlider: {
          name: "timerSlider",
          min: "1000",
          max: "100000",
          labelDesc: "timer-slider",
          callback: function() {
            vm.resources.timerSlider.defaultValue = this.value;
            vm.element.internal_config.timerSlider = this.value;
          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function () {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

            vm.element.rebuild(vm.element.internal_config);
          },
        },

        arrowOptions: {
          name: "arrowOptions",
          defaultValue: false,
          labelDesc: "arrow-resource_components-slide",
          callback: function() {
            vm.resources.arrowOptions.defaultValue = this.value;
            vm.element.internal_config.arrowOptions = this.value;
          }
        },
        arrowColor: {
          name: "arrowColor",
          defaultValue: '#d1d1d1',
          labelDesc: "arrow-color-slider",
          callback: function () {

            // console.log(this.colorValue);
            vm.resources.arrowColor.defaultValue = this.colorValue;
            vm.element.internal_config.arrowColor = this.colorValue;
          }
        },
        arrowSize: {
          name: "arrowSize",
          defaultValue: 25,
          labelDesc: "arrow-size-slider",
          callback: function () {

            // console.log(this.value);

            vm.resources.arrowSize.defaultValue = parseInt(this.value);
            vm.element.internal_config.arrowSize = parseInt(this.value) + 'px';
          }
        },
        autoPlaySlider: {
          name: "autoPlaySlider",
          defaultValue: true,
          labelDesc: "auto-play-slider",
          callback: function() {
            vm.resources.autoPlaySlider.defaultValue = this.value;
            vm.element.internal_config.autoPlaySlider = this.value;
          }
        },
        zIndex: {
          name: "zIndex",
          defaultValue: "",
          labelDesc: "zIndex",
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: "width",
          defaultValue: "150",
          min: "1",
          max: "1000",
          labelDesc: "width",
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + "px";
          }
        },
        height: {
          name: "height",
          defaultValue: "300",
          min: "1",
          max: "1000",
          labelDesc: "height",
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.height = this.value + "px";
          }
        },
        minHeight: {
          name: "minHeight",
          defaultValue: "50",
          min: "0",
          max: "2000",
          labelDesc: "minHeight",
          callback: function() {
            vm.resources.minHeight.defaultValue = this.value;
            vm.element.internal_config.minHeight = this.value + "px";

            vm.element.rebuild(vm.element.internal_config);
          }
        },
        border: {
          name: "border",
          defaultValue: "1px solid black",
          min: "0",
          max: "50",
          labelDesc: "border",
          callback: function() {
            let value = this.value + "px " + this.value2 + " " + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.border = value;
          }
        },
        opacity: {
          name: "opacity",
          defaultValue: "100",
          min: "0",
          max: "100",
          labelDesc: "opacity",
          callback: function() {
            vm.resources.opacity.defaultValue = this.value;
            vm.element.internal_config.opacity = this.value / 100;
          }
        },
        boxShadow: {
          name: "boxShadow",
          defaultValue: "0 0 0 0 black initial",
          min: "0",
          max: "50",
          labelDesc: "boxShadow",
          inset: false,
          callback: function() {
            let value =
              this.h +
              "px " +
              this.v +
              "px " +
              this.b +
              "px " +
              this.s +
              "px " +
              this.colorValue +
              " " +
              (this.i === true ? "inset" : "");

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.boxShadow = value;
          }
        },
        borderRadius: {
          name: "borderRadius",
          defaultValue: "0 0 0 0",
          min: "0",
          max: "360",
          labelDesc: "borderRadius",
          callback: function() {
            let value =
              this.v1 +
              "px " +
              this.v2 +
              "px " +
              this.v3 +
              "px " +
              this.v4 +
              "px";

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.borderRadius = value;
          }
        },
        padding: {
          name: "padding",
          defaultLeft: "15",
          defaultTop: "15",
          defaultRight: "15",
          defaultBottom: "15",
          min: "0",
          max: "100",
          labelDesc: "padding",
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + "px";

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + "px";

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + "px";

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + "px";
          }
        },
        // margin: {
        //   name: "margin",
        //   defaultLeft: "15",
        //   defaultRight: "15",
        //   min: "0",
        //   max: "50",
        //   labelDesc: "margin",
        //   callback: function() {
        //     vm.resources.margin.defaultLeft = this.l;
        //     vm.element.internal_config.marginLeft = this.l + "px";
        //
        //     vm.resources.margin.defaultRight = this.r;
        //     vm.element.internal_config.marginRight = this.r + "px";
        //   }
        // }
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;
      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      this.resources.timerSlider.defaultValue = parseInt(
        data.internal_config.timerSlider
      );
      this.resources.arrowOptions.defaultValue =
        data.internal_config.arrowOptions;

      this.resources.arrowSize.defaultValue = parseInt(data.internal_config.arrowSize);
      this.resources.arrowColor.defaultValue = data.internal_config.arrowColor;

      this.resources.autoPlaySlider.defaultValue =
        data.internal_config.autoPlaySlider;

      this.resources.width.defaultValue = parseInt(data.internal_config.width);
      this.resources.height.defaultValue = parseInt(
        data.internal_config.height
      );
      this.resources.minHeight.defaultValue = parseInt(
        data.internal_config.minHeight
      );

      this.resources.opacity.defaultValue = data.internal_config.opacity * 100;

      this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
      this.resources.borderRadius.defaultValue =
        data.internal_config.borderRadius;
      this.resources.border.defaultValue = data.internal_config.border;

      this.resources.padding.defaultLeft = parseInt(
        data.internal_config.paddingLeft
      );
      this.resources.padding.defaultTop = parseInt(
        data.internal_config.paddingTop
      );
      this.resources.padding.defaultRight = parseInt(
        data.internal_config.paddingRight
      );
      this.resources.padding.defaultBottom = parseInt(
        data.internal_config.paddingBottom
      );

      // this.resources.margin.defaultLeft = parseInt(
      //   data.internal_config.marginLeft
      // );
      // this.resources.margin.defaultRight = parseInt(
      //   data.internal_config.marginRight
      // );
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/SliderGallery/Resources.vue